export default __webpack_public_path__ + "static/media/bbp-campaigns-large.4587cbe8.png";